import { render, staticRenderFns } from "./remodel.vue?vue&type=template&id=0d1c8226&"
import script from "./remodel.vue?vue&type=script&lang=js&"
export * from "./remodel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports